// En tu archivo ControlSynergy.js
import React, { useState } from 'react';
import SynergyIntegration from '../components/SynergyIntegration';
import SchedulerControl from '../components/SchedulerControl'; // Asegúrate que la ruta es correcta

import {
  CalendarOutlined,
} from '@ant-design/icons';

import PageContainer from '../components/PageContainer';

function ControlSynergy() {
  const [showSynergy, setShowSynergy] = useState(false);
  const [showScheduler, setShowScheduler] = useState(false);

  return (
    <PageContainer
      title="Control Synergy"
      icon={<CalendarOutlined />}
      cardStyle={{
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
      }}
    >
      {/* Botones para mostrar los componentes */}
      <div style={{ marginBottom: '20px' }}>
        <button 
          onClick={() => setShowSynergy(!showSynergy)}
          style={{ marginRight: '10px', padding: '10px' }}
        >
          {showSynergy ? 'Ocultar' : 'Mostrar'} Integración Synergy
        </button>

        <button 
          onClick={() => setShowScheduler(!showScheduler)}
          style={{ padding: '10px' }}
        >
          {showScheduler ? 'Ocultar' : 'Mostrar'} Control Scheduler
        </button>
      </div>

      {/* Mostrar los componentes cuando se activan */}
      {showSynergy && <SynergyIntegration />}
      {showScheduler && <SchedulerControl />}
    </PageContainer>
  );
}

export default ControlSynergy;